<template>
  <div id="app" class="min-h-screen bg-gradient-to-br from-gray-900 via-indigo-950 to-slate-900">
    <router-view />
  </div>
</template>

<script setup lang="ts">
</script>
